const t="https://x.klarnacdn.net/kp/lib/v1/api.js";export{t as KLARNA_WIDGET_URL};
//# sourceMappingURL=constants.js.map
